import React, { useContext, useState } from 'react';
import DatePicker from 'react-datepicker';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { CategoryType } from '../../../controller/ProductController';
import { useToast } from '../../../controller/ToastController';
import { AuthContext } from '../../../navigation/AuthProvider';

const CouponEdit = () => {
  const navigate = useNavigate();
  const showToast = useToast();
  const oAuthContext = useContext(AuthContext);
  const location = useLocation();
  const couponInfo: CategoryType = location.state?.couponInfo;

  const [name, setName] = useState<string>('');
  const [discountType, setDiscountType] = useState<number>(0);
  const [discountPrice, setDiscountPrice] = useState<string>('');
  const [discountPercent, setDiscountPercent] = useState<string>('');
  const [expiredTime, setExpiredTime] = useState<Date>(new Date());
  const [isFinite, setIsFinite] = useState<number>(0);
  const [couponCount, setCouponCount] = useState<string>('');
  const [isMinPrice, setIsMinPrice] = useState<number>(0);
  const [minPrice, setMinPrice] = useState<string>('');

  const onChange_name = (event: any) => {
    setName(event.target.value);
  };
  const onChange_discountPrice = (event: any) => {
    setDiscountPrice(event.target.value);
  };
  const onChange_discountPercent = (event: any) => {
    setDiscountPercent(event.target.value);
  };
  const onChange_couponCount = (event: any) => {
    setCouponCount(event.target.value);
  };
  const onChange_minPrice = (event: any) => {
    setMinPrice(event.target.value);
  };

  // 필수 확인
  const checkRequired = () => {
    if (name.length > 0) return true;
    return false;
  };

  // API 호출
  // const setCategoryData = async () => {
  //   try {
  //     if (checkRequired()) {
  //
  //       const productTemp: any = [];
  //       productList.map((item: ProductType) => {
  //         productTemp.push({ product_id: item.prd_id, is_set: item.is_set });
  //       });
  //       console.log(productTemp);

  //       if (categoryInfo) {
  //         const category = {
  //           name: name,
  //           category_id: categoryInfo.category_id,
  //           is_main: 1,
  //           is_for_adult: checkAdult,
  //           product_list: productTemp,
  //         };
  //         const oRes = await ProductController.editCateProduct(currentStore.value, category); // test
  //         if (oRes && oRes.data) {
  //           const oResponse = oRes.data;
  //           console.log('editCateProduct', oResponse);
  //           if (oResponse.data && oResponse.ok) {
  //             // console.log(productTemp);
  //             showToast('새로운 상품분류 정보를 등록했어요');
  //           }
  //         }
  //       } else {
  //         const category = {
  //           name: name,
  //           is_for_adult: checkAdult,
  //           product_list: productTemp,
  //         };
  //         const oRes = await ProductController.setCateProduct(currentStore.value, category); // test
  //         if (oRes && oRes.data) {
  //           const oResponse = oRes.data;
  //           console.log('setCateProduct', oResponse);
  //           if (oResponse.data && oResponse.ok) {
  //             // console.log(productTemp);
  //             showToast('새로운 상품분류 정보를 등록했어요');
  //             navigate(-1);
  //           }
  //         }
  //       }
  //     } else {
  //       showToast('필수 정보를 입력해주세요', 'error');
  //     }
  //   } catch (err) {
  //     console.log('err---->', err);
  //   }
  // };
  // const deleteCategoryData = async () => {
  //   try {
  //     const oRes = await ProductController.delCategory(categoryInfo.category_id);
  //     if (oRes && oRes.data) {
  //       const oResponse = oRes.data;
  //       console.log('delCategory', oResponse);
  //       if (oResponse.data && oResponse.ok) {
  //         showToast('상품분류를 삭제했어요');
  //         navigate(-1);
  //       }
  //     }
  //   } catch (err) {
  //     console.log('err---->', err);
  //   }
  // };

  // useEffect(() => {
  //   console.log(categoryInfo);
  //   if (categoryInfo) {
  //     setName(categoryInfo.category_name);
  //     setCheckAdult(categoryInfo.is_for_adult);
  //     setProductList([...categoryInfo.product_list]);
  //   }
  // }, []);

  return (
    <Style>
      <div className="contentContainer">
        <div className="editHeaderWrap">
          <button className="backButton" onClick={() => navigate(-1)}>
            <img src={`${process.env.PUBLIC_URL}/svg/ic_arrow_left.svg`} alt="ic" />
          </button>
          {couponInfo && (
            <button className="deleteButton">
              <img src={`${process.env.PUBLIC_URL}/svg/ic_trashcan_green.svg`} alt="ic" />
              <h5>쿠폰 삭제</h5>
            </button>
          )}
        </div>
        <div className="inputText contentWrap">
          <div className="title">
            <h4>쿠폰명</h4>
          </div>
          <input
            type="text"
            placeholder="쿠폰명을 적어주세요"
            value={name}
            onChange={onChange_name}
            autoFocus={true}
          />
        </div>
        <div className="inputText contentWrap">
          <div className="title">
            <h4>할인 방식 선택</h4>
          </div>
          <div className="selectBoxWrap">
            <div
              className={`selectBox left ${discountType === 0 && 'active'}`}
              onClick={() => setDiscountType(0)}>
              정액할인
            </div>
            <div
              className={`selectBox right ${discountType === 1 && 'active'}`}
              onClick={() => setDiscountType(1)}>
              정률할인
            </div>
          </div>
          {discountType === 0 ? (
            <div className="inputWrap">
              <div className="unit">원</div>
              <input
                type="text"
                value={discountPrice}
                placeholder="0"
                onChange={onChange_discountPrice}
                autoFocus={false}
              />
            </div>
          ) : (
            <div className="inputWrap">
              <div className="unit">%</div>
              <input
                type="text"
                value={discountPercent}
                placeholder="0"
                onChange={onChange_discountPercent}
                autoFocus={false}
              />
            </div>
          )}
        </div>
        <div className="inputText contentWrap">
          <div className="title">
            <h4>쿠폰 기간</h4>
          </div>
          <div className="calendarWrap">
            <DatePicker
              className="datePicker"
              selectsRange={true}
              dateFormat="yyyy-MM-dd"
              isClearable={false}
              locale="ko"
              value={new Date().toString()}
              onChange={(e: any) => setExpiredTime(e)}
              disabledKeyboardNavigation={true}
              onFocus={(e) => {
                e.preventDefault();
                e.target.blur();
              }}
            />
            <div className="calendar">
              <img src={`${process.env.PUBLIC_URL}/svg/ic_calendar.svg`} alt="달력아이콘" />
            </div>
          </div>
        </div>
        <div className="inputText contentWrap">
          <div className="title">
            <h4>쿠폰 수량</h4>
          </div>
          <div className="selectBoxWrap">
            <div
              className={`selectBox left ${isFinite === 0 && 'active'}`}
              onClick={() => setIsFinite(0)}>
              정해진 수량
            </div>
            <div
              className={`selectBox right ${isFinite === 1 && 'active'}`}
              onClick={() => setIsFinite(1)}>
              제한 없음
            </div>
          </div>
          {isFinite === 0 && (
            <div className="inputWrap">
              <div className="unit">원</div>
              <input
                type="text"
                value={couponCount}
                placeholder="0"
                onChange={onChange_couponCount}
                autoFocus={false}
              />
            </div>
          )}
        </div>
        <div className="inputText">
          <div className="title">
            <h4>쿠폰 사용 시 최소 주문금액</h4>
          </div>
          <div className="selectBoxWrap">
            <div
              className={`selectBox left ${isMinPrice === 0 && 'active'}`}
              onClick={() => setIsMinPrice(0)}>
              있음
            </div>
            <div
              className={`selectBox right ${isMinPrice === 1 && 'active'}`}
              onClick={() => setIsMinPrice(1)}>
              없음
            </div>
          </div>
          {isMinPrice === 0 && (
            <div className="inputWrap">
              <div className="unit">원</div>
              <input
                type="text"
                value={minPrice}
                placeholder="0"
                onChange={onChange_minPrice}
                autoFocus={false}
              />
            </div>
          )}
        </div>

        <button className={`submitButton ${!checkRequired() && 'inactive'}`}>저장</button>
      </div>
    </Style>
  );
};

export default CouponEdit;

const Style = styled.div`
  .contentContainer:nth-child(1) {
    border-radius: 10px 10px 0 0;
  }
  .contentContainer:nth-child(2) {
    border-radius: 0 0 10px 10px;
  }
  .contentWrap {
    padding-bottom: 4%;
  }
  .editHeaderWrap {
    margin-left: -50px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .deleteButton {
      display: flex;
      align-items: center;
      padding: 6px 10px;
      border: 1px solid #40977f;
      border-radius: 5px;
      gap: 10px;
      h5 {
        color: #40977f;
      }
    }
  }

  .selectBoxWrap {
    display: flex;
    align-items: center;
    padding-bottom: 10px;

    .selectBox {
      flex: 1;
      border: 1px solid #cecece;
      background: #f7f7f7;
      font-size: 14px;
      line-height: 20px;
      color: #555555;
      padding: 8px 0;
      text-align: center;
      cursor: pointer;
    }
    .selectBox.left {
      border-radius: 5px 0px 0px 5px;
      border-right: none;
    }
    .selectBox.right {
      border-radius: 0px 5px 5px 0px;
      border-left: none;
    }
    .selectBox.active {
      border: 1px solid #4dd2ae;
      background: #ecf5f3;
      color: #40977f;
    }
  }

  .inputText {
    .row.gap {
      gap: 10px;
      align-items: flex-end;
    }

    img {
      cursor: pointer;
    }

    .title {
      padding: 30px 0 6px 0;
      display: flex;
      align-items: center;
      gap: 6px;

      h5 {
        color: #40977f;
        font-weight: 500;
      }
      .imageSpan {
        color: #979797;
        font-weight: 400;
      }
      h4 {
        color: #555555;
      }
    }
    .title.initial {
      padding: 0 0 6px 0;
    }

    .inputWrap {
      position: relative;
      .unit {
        position: absolute;
        font-size: 16px;
        line-height: 22px;
        color: #a7a7a7;
        top: 50%;
        transform: translateY(-50%);
        right: 20px;
      }
    }
  }

  input,
  textarea {
    width: 100%;
    padding: 10px 12px;
    border: 1px solid #cecece;
    border-radius: 5px;
    color: #979797;
  }

  input::placeholder,
  textarea::placeholder {
    color: #a7a7a7;
  }

  .calendarWrap {
    position: relative;
    width: 100%;

    .calendar {
      position: absolute;
      right: 20px;
      top: 9px;
    }
  }
  // 전체
  .react-datepicker {
    box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.25);
    border-radius: 10px;
    border: 1px solid #4dd2ae;
  }
  // 헤더
  .react-datepicker__header {
    background: #ecf5f3;
    border-bottom: 1px solid #4dd2ae;
    border-radius: 10px 10px 0 0;
  }
  // 현재연월
  .react-datepicker__current-month {
    color: #40977f;
  }
  // 요일
  .react-datepicker__day-name {
    width: 28px;
    color: #40977f;
    font-weight: 500;
  }
  // 일요일
  .react-datepicker__day-name:nth-child(1) {
    color: #ff7e7e;
  }
  // 토요일
  .react-datepicker__day-name:nth-child(7) {
    color: #67a4ff;
  }

  // 날짜
  .react-datepicker__day {
    width: 28px;
    height: 28px;
    border-radius: 5px;
    font-weight: 400;
  }
  // 선택불가
  .react-datepicker__day--disabled {
    color: #cecece !important;
    pointer-events: none;
  }

  // 일요일
  .react-datepicker__day:nth-child(1) {
    color: #ff7e7e;
  }
  // 토요일
  .react-datepicker__day:nth-child(7) {
    color: #67a4ff;
  }

  // 범위
  .react-datepicker__day--in-selecting-range,
  .react-datepicker__day--in-range {
    background: #ecf5f3;
    border: 1px solid #4dd2ae;
    color: #40977f !important;
  }
  // 현재
  .react-datepicker__day--today {
    border: 1px solid #4dd2ae !important;
    color: #40977f;
    background: #ffffff;
  }

  // 말꼬리
  .react-datepicker__triangle {
    display: none;
  }
  // 위치
  .react-datepicker-popper {
    padding: 10px 0 0 0;
  }

  // outside
  .react-datepicker__day--outside-month {
    background: #fff !important;
    border: none;
  }
  .react-datepicker__week {
    display: flex;
    align-items: center;
  }
  // 범위 시작일
  .react-datepicker__day--range-start {
    background: #4dd2ae !important;
    border: 1px solid #4dd2ae !important;
    color: #ffffff !important;
    font-weight: 500;
  }
  // 범위 종료일
  .react-datepicker__day--range-end {
    background: #4dd2ae !important;
    border: 1px solid #4dd2ae !important;
    color: #ffffff !important;
    font-weight: 500;
  }
`;
